module.exports = "<div class=\"c-toggle\">\n    <div class=\"c-toggle__options-wrapper\">\n        <button class=\"c-toggle__option\" :class=\"{'is-selected': isSelected == option.id}\" v-for=\"option in toggleData.options\" @click=\"toggle(toggleData.name, option.id)\" @keyup.enter=\"toggle(toggleData.name, option.id)\"><span>{{option.title}}</span></button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/toggle/toggle.vhtml
// module id = 319
// module chunks = 0